<template lang="pug">
  .component-driver-coupon
    .title
      h2 Driver coupons
    base-list(:component="component", :dataLoader="dataLoader")

</template>
<script type="text/babel">
import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import BaseList from "../../../pages/backoffice/BaseList";

export default {
  name: "DriverCoupons",
  components: {
    BaseList,
  },
  data() {
    return {
      component: require('src/components/backoffice/CouponInUse.vue'),
    }
  },
  created() {
  },
  methods: {
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.drivers.list(page, resultsPerPage, {id: this.$route.params.id}).coupons(page = 1, resultsPerPage = 25, (data) => {
        callback(data)
      })
    }
  },


}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverCoupons.vue?0288b4a1